export default class TextUtilities {
    public static formatBulletPoints(text: string): string {
        if (!text) return "";

        return (
            text
                // white space
                .replace(/\s+/g, " ")

                // main bullet points
                .replace(/\s*•\s*/g, "\n• ")

                // sub bullet points
                .replace(/\s*o\s+/g, "\n    o ")

                // remove initial \n
                .trimStart()
        );
    }
}
